import { getAskSigninReturnState } from '../utils/askNavigation';

const isAskPath = (path) => path.split(/[?#]/, 1)[0] === '/ask';

export const getSigninRedirect = (requestedPath, navigationState) => {
    const path = typeof requestedPath === 'string' && requestedPath.startsWith('/') &&
        !requestedPath.startsWith('//') && !requestedPath.includes('\\') &&
        Array.from(requestedPath).every((character) => character.charCodeAt(0) >= 32)
        ? requestedPath : '/home';
    return {
        path,
        replace: isAskPath(path),
        state: isAskPath(path)
            ? getAskSigninReturnState(navigationState?.signinRedirectState)
            : undefined,
    };
};

export const navigateToSigninWithRedirect = (navigate, redirectPath, replace = false, routeState) => {
    let returnPath = redirectPath;
    let state;
    if (isAskPath(redirectPath)) {
        const url = new URL(redirectPath, 'https://app.local');
        // Ask has already consumed this prefill. Its session now owns the draft.
        url.searchParams.delete('q');
        returnPath = `${url.pathname}${url.search}${url.hash}`;
        state = { signinRedirectState: getAskSigninReturnState(routeState) };
    }
    const encodedPath = encodeURIComponent(returnPath);
    // Navigate to signin with redirect param.
    navigate(`/sign_in?redirect=${encodedPath}`, { replace, ...(state ? { state } : {}) });
};
